export default __webpack_public_path__ + "static/media/credential.4cc03ef4.png";